import(/* webpackMode: "eager", webpackExports: ["CourseLink"] */ "/vercel/path0/app/Components/CoursePeek/CourseLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
